'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.InputCheckbox',

  propTypes: {
    value: _propTypes2['default'].bool.isRequired,
    onChange: _propTypes2['default'].func.isRequired
  },

  handleChange: function handleChange() {
    this.props.onChange(!this.props.value);
  },

  render: function render() {
    return _react2['default'].createElement('input', {
      type: 'checkbox',
      checked: this.props.value,
      onChange: this.handleChange
    });
  }

});
module.exports = exports['default'];